import Vue from "vue";
const envType = process.env.VUE_APP_CURRENTMODE;
const isDev = process.env.NODE_ENV === 'development' || envType === 'stage';

// 域名池
const DOMAIN_POOL = [
  'https://biz.authorcenters.com',
  'https://biz.authorplatforms.top',
  'https://biz.authorplatformi.com',
  'https://biz.authorcenters.top',
  'https://biz.authorplatformi.top',
  'https://biz.authormakes.com',
  'https://biz.authoruses.top',
  'https://biz.authorbackup.com',
  'https://biz.authorbackup.top',
  'https://biz.authormakes.top',
];

let pointer = Math.floor(Math.random() * DOMAIN_POOL.length);

const getNextDomain = () => {
  const domain = DOMAIN_POOL[pointer];
  pointer = (pointer + 1) % DOMAIN_POOL.length;
  return domain;
};

const baseURL = {};

if (isDev) {
  // 开发/测试环境：动态域名配置
  baseURL.AHEAD = 'http://test-biz.meetnovel.com'
  baseURL.AUTHOR = 'http://test-biz.meetnovel.com/author'
  baseURL.NOTICE = 'http://test-biz.meetnovel.com/notice'
  baseURL.CONSUME = 'http://test-biz.meetnovel.com/consume'
  baseURL.CDNCONSUME = 'http://test.cdn.meetnovel.com/consume' // 废弃
  baseURL.SEARCH = 'http://test-search.meetnovel.com/search' // 废弃
  baseURL.IMG = "http://test-img.meetnovel.com" // 废弃
} else if (envType === 'prod') {
  // 生产环境
  Object.defineProperties(baseURL, {
    AHEAD: {
      get() { return getNextDomain() },
      enumerable: true
    },
    AUTHOR: {
      get() { return `${getNextDomain()}/author` },
      enumerable: true
    },
    NOTICE: {
      get() { return `${getNextDomain()}/notice` },
      enumerable: true
    },
    CONSUME: {
      get() { return `${getNextDomain()}/consume` },
      enumerable: true
    },
    //   baseURL.AHEAD = 'https://biz.meetnovel.com';
    //   baseURL.AUTHOR = 'https://biz.meetnovel.com/author';
    //   baseURL.NOTICE = 'https://biz.meetnovel.com/notice';
    //   baseURL.CONSUME = 'https://biz.meetnovel.com/consume';
    CDNCONSUME: { value: 'https://cdn.meetnovel.com/consume' }, // 废弃
    SEARCH: { value: 'https://search.meetnovel.com/search' }, // 废弃
    IMG: { value: 'https://img.meetnovel.com' } // 废弃
  });
  Vue.prototype.isShowA = false;
}

export default baseURL;